// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__4k8kA","label":"CategoryService_label__1MJ9B","location":"CategoryService_location__oDf-1"};